document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.how-card video');


  // Check if screen is Desktop or Mobile
  const isDesktop = window.innerWidth >= 750;


  if (isDesktop) {
    // DESKTOP: Keep hover effect
    videos.forEach(video => {
      video.pause();
      video.currentTime = 0;


      const parent = video.parentElement;
      parent.addEventListener('mouseenter', () => video.play().catch(() => {}));
      parent.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    });
  } else {
    // MOBILE: Autoplay automatically when scrolled into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }, { threshold: 0.4 }); // Plays when 40% of the video is on screen


    videos.forEach(video => observer.observe(video));
  }
});
